export default __webpack_public_path__ + "static/media/shivank.ad843091.jpeg";